
import { defineComponent, ref, watch, nextTick } from 'vue';

export default defineComponent({
  name: 'ImgFullscreen',
  inheritAttrs: false,
  setup() {
    const rootEl = ref<HTMLElement | null>(null);
    const expanded = ref(false);
    const cloned = ref<HTMLElement | null>(null);

    const closeImage = () => {
      expanded.value = false;
    };

    const removeClonedImage = () => {
      if (cloned.value) {
        cloned.value.remove();
        cloned.value = null;
      }
    };

    watch(expanded, (newVal) => {
      nextTick(() => {
        if (newVal) {
          const el = rootEl.value;
          if (!el) return;
          const node = el.cloneNode(true) as HTMLElement;
          cloned.value = node;
          node.addEventListener('click', closeImage);
          node.addEventListener('wheel', closeImage);
          document.body.appendChild(node);

          setTimeout(() => {
            node.style.opacity = '1';
          }, 0);
        } else {
          const node = cloned.value;
          if (node) {
            node.style.opacity = '0';
            node.addEventListener('transitionend', removeClonedImage);
          }
        }
      });
    });

    return {
      rootEl,
      expanded,
      closeImage,
    };
  },
});
